import { useEffect, useCallback, useRef } from 'react';
import { canUseDOM } from '../utils/environment';
export var useAppearanceFocus = function useAppearanceFocus(appeared, focusableRef) {
  var activeElementRef = useRef(null);
  var focus = useCallback(function (element) {
    setTimeout(function () {
      if (element) {
        element.focus();
      }
    });
  }, []);
  useEffect(function () {
    if (focusableRef && focusableRef.current && appeared) {
      focus(focusableRef.current);
    }
  }, [focusableRef, appeared]);
  useEffect(function () {
    if (appeared) {
      if (!activeElementRef.current && canUseDOM()) {
        activeElementRef.current = document.activeElement;
      }
    } else {
      var activeElement = activeElementRef.current;
      focus(activeElement);
      activeElementRef.current = null;
    }
  }, [appeared]);
};